import { z } from 'zod';

export const AiPointLedgerQuery = z
  .object({
    cursor: z.string().trim().min(1).max(400).optional(),
    from: z.string().datetime({ offset: true }).optional(),
    to: z.string().datetime({ offset: true }).optional(),
    limit: z.coerce.number().int().min(1).max(50).default(10),
  })
  .refine((value) => !value.from || !value.to || Date.parse(value.from) < Date.parse(value.to), {
    message: '`from` must be earlier than `to`',
  });

export type AiPointLedgerQueryInput = z.input<typeof AiPointLedgerQuery>;

export interface AiPointLedgerItem {
  id: string;
  feature_key: string;
  ref_type: string;
  ref_id: string;
  model_id: string | null;
  model_display_name: string | null;
  status: 'settled';
  points: number;
  created_at: string;
}

export interface AiPointLedgerResponse {
  items: AiPointLedgerItem[];
  next_cursor: string | null;
}
